import debounce from 'lodash/debounce';
import api from '@/factories/api';

const pendingIds = new Set();

const flush = debounce(async (commit) => {
  const ids = Array.from(pendingIds);
  pendingIds.clear();
  if (!ids.length) return;

  try {
    const data = await api().post('contacts/resolve', { ids });
    const results = Array.isArray(data) ? data : [];
    if (results.length) {
      commit('mergeResolved', results);
    }

    const foundIds = new Set(results.map((c) => c.id));
    const notFound = ids.filter((id) => !foundIds.has(id));
    if (notFound.length) {
      commit('markNotFound', notFound);
    }
  } catch (e) {
    pendingIds.forEach((id) => pendingIds.delete(id));
  }
}, 300);

export default {
  namespaced: true,

  state: {
    contacts: {},
  },

  mutations: {
    mergeResolved(state, contacts) {
      const updated = { ...state.contacts };
      for (const contact of contacts) {
        updated[contact.id] = contact;
      }
      state.contacts = updated;
    },

    markNotFound(state, ids) {
      const updated = { ...state.contacts };
      for (const id of ids) {
        if (!updated[id]) {
          updated[id] = { id, name: '', not_found: true };
        }
      }
      state.contacts = updated;
    },
  },

  actions: {
    resolve({ state, commit }, ids) {
      const list = Array.isArray(ids) ? ids : [ids];
      let hasNew = false;

      for (const id of list) {
        if (id && !state.contacts[id] && !pendingIds.has(id)) {
          pendingIds.add(id);
          hasNew = true;
        }
      }

      if (hasNew) {
        flush(commit);
      }
    },
  },

  getters: {
    resolved: (state) => (id) => state.contacts[id] || null,
    resolvedName: (state) => (id) => state.contacts[id]?.name || null,
  },
};
